<template>
  <div class="row reverse-mobile">
    <div class="col-12 col-md-3">
      <UserMenu></UserMenu>
    </div>

    <div class="col-12 col-md-9">
      <div class="row">
        <div class="card w-100">
          <div class="card-body">
            <div class="d-flex flex-row align-items-center">
              <i class="material-icons material-icons-title mr-2">perm_media</i>
              <h3 class="card-title mt-2">Edit Media Item</h3>
            </div>

            <div class="d-none d-md-flex justify-content-between align-items-center">
              <div class="py-4 pr-5">
                <h4 class="card-title">{{name}}</h4>
                <p class>{{description}}</p>
              </div>
              <img v-bind:src="signedThumbUrl" v-bind:alt="name" />
            </div>

            <div class="form-group mb-0">
              <form enctype="multipart/form-data" method="post" name="form" @submit.prevent="save">
                <div class="alert alert-danger" v-if="errorFound">
                  <strong>Whoops!</strong> We had some trouble updating your
                  media.
                </div>

                <h5>Name:</h5>
                <input
                  @change="formChanged"
                  type="text"
                  name="name"
                  id="name"
                  v-model="name"
                  class="form-control mb-3"
                  maxlength="200"
                />
                <h5>Description:</h5>
                <textarea
                  @change="formChanged"
                  type="text"
                  name="description"
                  id="description"
                  v-model="description"
                  class="form-control mb-3"
                  maxlength="200"
                />

                <h5>Tags:</h5>
                <TagSelector
                  @change="formChanged"
                  @tag-selection-updated="tagsUpdated"
                  :availableTags="getAvailableTags"
                  :startingTags="getStartingTags"
                ></TagSelector>

                <div class="div d-flex mt-4">
                  <button
                    class="btn btn-primary d-flex align-items-center justify-content-center w-25"
                    type="submit"
                    name="edit"
                  >
                    <i class="material-icons">save</i> Save Changes
                  </button>
                  <button
                    type="button"
                    class="btn btn-danger d-flex align-items-center justify-content-center w-25 ml-2"
                    v-on:click="DeleteMedia()"
                  >
                    <i class="material-icons">delete</i> Delete Scenario
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TagSelector from "../components/TagSelector";
import UserMenu from "../components/UserMenu";
import mediaService from "../services/media.service";

export default {
  name: "EditMedia",
  components: {
    TagSelector,
    UserMenu
  },
  data: function() {
    return {
      uuidId: this.$route.params.uuidId,
      unsavedChanges: false,
      scenarioUpdated: false,
      errorFound: false,
      name: "",
      description: "",
      availableTags: [],
      selectedTags: [],
      signedThumbUrl: ""
    };
  },
  methods: {
    getAvailableTags() {
      return mediaService.mediaTags();
    },
    getStartingTags() {
      return mediaService.mediaItem(this.uuidId);
    },
    init() {
      mediaService.mediaItem(this.uuidId).then(data => {
        this.description = data.description;
        for (let i = 0; i < data.tags.length; i++) {
          this.selectedTags.push(data.tags[i].id);
        }
        this.name = data.name;
        this.signedThumbUrl = data.signed_thumb_url;
        this.setRouteParams("Edit Media: " + this.name);
      });
    },

    formChanged() {
      this.unsavedChanges = true;
    },

    save() {
      const swalWithBootstrapButtons = vm.$swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger"
        },
        buttonsStyling: false
      });
      this.mediaUpated = false;
      this.errorFound = false;
      let data = {
        name: this.name,
        description: this.description,
        tags: this.selectedTags
      };
      data = JSON.stringify(data);
      mediaService
        .editMedia(data, this.uuidId)
        .then(data => {
          swalWithBootstrapButtons.fire(
            "Updated!",
            "Your media has been updated.",
            "success"
          );
          this.errorFound = false;
          this.mediaUpated = true;
          this.unsavedChanges = false;
        })
        .catch(error => {
          this.mediaUpated = false;
          this.errorFound = true;
          this.unsavedChanges = false;
        });
    },
    tagsUpdated(tags) {
      this.selectedTags = tags;
    },

    DeleteMedia() {
      const swalWithBootstrapButtons = vm.$swal.mixin({
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: "btn btn-primary"
        },
        buttonsStyling: false
      });

      swalWithBootstrapButtons
        .fire({
          title: "Delete " + this.name + "?",
          html:
            "Deleting media will remove it from Community, including groups. Users who have already downloaded the media to their device will still have access to it.<br> <br> If you still want access to your media in Community you can always change its visibility to private.",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Delete"
        })
        .then(result => {
          if (result.value) {
            this.unsavedChanges = false;
            mediaService.deleteMedia(this.uuidId).then(data => {
              swalWithBootstrapButtons.fire(
                "Deleted!",
                "Media deleted.",
                "success"
              );
              this.$router.push("/me/media");
            });
          }
        });
    },
    setRouteParams(param) {
      this.$route.meta.breadcrumb.label = param;
      this.$router.replace({ query: { temp: Date.now() } });
      this.$router.replace({ query: { temp: undefined } });
    }
  },
  beforeMount() {
    this.init();
  },
  beforeRouteLeave(to, from, next) {
    if (this.unsavedChanges) {
      const swalWithBootstrapButtons = vm.$swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-danger"
        },
        buttonsStyling: false
      });
      swalWithBootstrapButtons
        .fire({
          title: "Leave without saving changes?",
          type: "question",
          showCancelButton: true,
          confirmButtonText: "Continue"
        })
        .then(result => {
          if (result.value) {
            next();
          }
          next(false);
        });
    } else {
      next();
    }
  }
};
</script>

<style>
.swal2-popup .swal2-icon.swal2-warning {
  color: #dc3545;
  border-color: #dc3545;
}

.swal2-popup .swal2-icon.swal2-question {
  color: #CB2E37;
  border-color: #CB2E37;
}

.swal2-icon.swal2-success {
  color: #28a745;
  border-color: #28a745;
}

.swal2-popup .swal2-title {
  color: #CB2E37;
  font-weight: 600;
}

.swal2-popup .swal2-content {
  color: #6c757d;
  margin-right: 10px;
  font-size: 1rem;
  font-style: italic;
}

.swal2-popup .swal2-confirm {
  margin-right: 5px;
}

.swal2-popup .swal2-cancel {
  margin-left: 5px;
}

.swal2-popup .swal2-icon.swal2-warning {
  color: #dc3545;
  border-color: #dc3545;
}

.swal2-popup .swal2-icon.swal2-question {
  color: #CB2E37;
  border-color: #CB2E37;
}

.swal2-icon.swal2-success {
  color: #28a745;
  border-color: #28a745;
}

.swal2-popup .swal2-title {
  color: #CB2E37;
  font-weight: 600;
}

.swal2-popup .swal2-content {
  color: #6c757d;
  margin-right: 10px;
  font-size: 1rem;
  font-style: italic;
}

.swal2-popup .swal2-confirm {
  margin-right: 5px;
}

.swal2-popup .swal2-cancel {
  margin-left: 5px;
}
</style>

<style scoped>
img {
  max-height: 150px;
  width: auto;
}

.preview-container {
  position: relative;
  min-height: 260px;
  max-width: 100%;
  width: 100%;
  height: auto;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  opacity: 0;
}

.media-type-overlay {
  position: absolute;
  z-index: 999;
  top: 0;
  right: 0;
  opacity: 0.5;
}

.media-type-overlay i {
  color: #fff;
  font-size: 80px;
}
.media-stats i {
  margin-right: 5px;
}

.material-icons-title {
  font-size: 40px;
  color: #7d7d7d;
}

textarea {
  height: 100px;
}
</style>